import React, { useContext } from 'react';

import { MaxPendingDrafts } from 'common/constants/autopilotActions';
import { RouterContext } from 'common/containers/RouterContainer';
import AdminQueueAlert, {
  AlertTypes,
} from 'common/subdomain/admin/AdminQueue/AdminQueueAlerts/AdminQueueAlert';
import ButtonV2 from 'common/ui/ButtonV2';
import { P } from 'common/ui/Text';

import type { Company } from 'common/api/endpoints/companies';

type Props = {
  company: Company;
};

const AdminQueueDraftLimit = ({ company }: Props) => {
  const router = useContext(RouterContext);

  const isIDBEnabled = company?.featureAllowlist?.includes('idea-database');
  const isAutopilotAutomated = company.queueAutomation?.enabled || isIDBEnabled;

  if (isAutopilotAutomated) {
    return null;
  }

  return (
    <AdminQueueAlert
      type={AlertTypes.error}
      text={
        <P>
          Autopilot has {MaxPendingDrafts} suggestions and is paused. Review your suggestions or
          enable automatic actions to continue processing feedback.
        </P>
      }
      actions={
        <ButtonV2
          onClick={() => router.push('/admin/settings/autopilot/feedback-discovery')}
          size="medium">
          Automate actions
        </ButtonV2>
      }
    />
  );
};

export default AdminQueueDraftLimit;
